import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';

export default class ParityManagerFiltersMarketInfo extends Model {
  [Type] = 'parity-manager/filters/market-info' as const;

  @attr('string') declare name: string;

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get formattedName() {
    return this.name;
  }

  // Required to use as @options argument for (Combo)SelectInput component
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get label() {
    return this.formattedName;
  }
}
